<script src="../../../config/qm-environment-config.js"></script>
<template>
  <div v-if="item" class="qm-panel">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-3 col-lg-4 qm-item-row">
        <div v-if="showSelect" class="form qm-name-select-wrapper">
          <label class="col-form-label hidden-md-up qm-item-label" for="qm-name-select">Name</label>
          <v-select v-if="standardSurveyItemsOrdered.length > 0" v-model="selectedItem" ref="itemSelect" label="label" value="value" @input="updateName" :options="standardSurveyItemsOrdered" :filterBy="filterIgnoringAccentsAndCase" id="qm-name-select"></v-select>
          <button v-on:click="toggleView" type="button" class="btn btn-turquois qm-button-narrow"><i class="fa fa-terminal"></i></button>
        </div>
        <div v-else class="form form-inline qm-name-select-wrapper">
          <label for="itemName" class="col-form-label hidden-md-up qm-item-label">Name</label>
          <input v-model="item.itemName" v-on:blur="updateName" id="itemName" ref="itemInput" class="form-control qm-select">
          <button v-on:click="toggleView" type="button" class="btn btn-turquois qm-button-narrow"><i class="fa fa-align-justify"></i></button>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2 qm-item-row">
        <div class="form form-inline">
          <label for="qm-input-volume" class="col-form-label hidden-md-up qm-item-label">{{ volumeUnit }}</label>
          <button v-on:click="decreaseVolume" type="button" class="btn btn-turquois qm-button-narrow ripple"><i class="fa fa-chevron-down"></i></button>
          <input v-model.number="item.volume" v-on:change="updateVolume" min="0" step="0.01" type="number" id="qm-input-volume" class="form-control qm-input-count number-input-without-controls">
          <button v-on:click="increaseVolume" type="button" class="btn btn-turquois qm-button-narrow ripple"><i class="fa fa-chevron-up"></i></button>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2 qm-item-row">
        <div class="form-inline">
          <label for="qm-input-count" class="col-form-label hidden-md-up qm-item-label">Count</label>
          <button v-on:click="decreaseCount" type="button" class="btn btn-turquois qm-button-narrow ripple"><i class="fa fa-chevron-down"></i></button>
          <input v-model.number="item.count" v-on:change="updateCount" type="number" min="0" step="1" id="qm-input-count" class="form-control qm-input-count number-input-without-controls">
          <button v-on:click="increaseCount" type="button" class="btn btn-turquois qm-button-narrow ripple"><i class="fa fa-chevron-up"></i></button>
        </div>
      </div>
      <div class="col-12 col-sm-11 col-md-2 col-lg-3 qm-item-row">
        <div class="form-inline">
          <label class="col-form-label hidden-md-up qm-item-label" for="qm-mode-select">Mode</label>
          <select v-model="item.mode" v-on:load="updateMode" v-on:change="updateMode" class="custom-select qm-select" name="qm-mode-select" v-bind:style="{ backgroundColor: modeColor }">
            <option v-for="option in modeOptions" v-bind:value="option.id">{{ option.text }}</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-sm-1 col-md-1 col-lg-1">
        <button v-if="item.weight === null" v-on:click="showItemDetails" type="button" class="btn btn-warning qm-item-detail-button pull-right"><i class="fa fa-exclamation-circle"></i></button>
          <button v-else v-on:click="showItemDetails" type="button" class="btn btn-turquois qm-item-detail-button pull-right"><i class="fa fa-address-card"></i></button>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '../../event-bus'
export default {
  name: 'Item',
  data: () => ({
    showSelect: true,
    selected: null,
    selectedItem: null,
    modeColor: '#ffffff'
  }),
  props: ['item', 'volumeUnit', 'standardSurveyItemsOrdered', 'modeOptions', 'clientLanguage'],
  computed: {
    itemStorageKey () {
      return 'survey-' + this.session.surveyId + '-room-' + this.session.roomId + '-item-' + this.item.itemId
    },
    volumeStep () {
      return this.$hasMetricUnits() ? 0.1 : 1
    },
    ...mapGetters({
      session: 'getSession'
    })
  },
  created: function () {
    this.showSelectOrInput()
    this.evaluateModeColor()
  },
  methods: {
    showSelectOrInput: function () {
      this.item.itemName !== '' ? this.showSelect = false : this.showSelect = true
      // fill the v-select box with value / label on load
      if (this.showSelect) {
        let item = this.standardSurveyItemsOrdered.filter((item) => {
          return item.value === this.item.itemNameId
        })
        if (item.length > 0) {
          this.selectedItem = item[0]
        }
      }
    },
    evaluateModeColor: function () {
      var currentMode = this.modeOptions.filter((mode) => { return mode.id === this.item.mode })[0]
      if (typeof currentMode !== 'undefined') {
        if (currentMode.hasOwnProperty('color')) {
          this.modeColor = currentMode.color
        } else {
          this.modeColor = '#ffffff'
        }
      } else {
        this.modeColor = '#ffffff'
      }
    },
    updateCount: function () {
      this.$store.dispatch('updateItemCount', {
        storageKey: this.itemStorageKey,
        count: Number(this.item.count)
      }).then(() => {
        EventBus.$emit('calculateVolumes')
      })
    },
    updateMode: function () {
      this.$store.dispatch('updateItemMode', {
        storageKey: this.itemStorageKey,
        mode: this.item.mode
      }).then(() => {
        this.evaluateModeColor()
        EventBus.$emit('calculateVolumes')
      })
    },
    showItemDetails: function () {
      const vue = this
      this.$store.dispatch('selectItem', this.item.itemId)
        .then(() => {
          vue.$router.push({ name: 'item-detail' })
        })
    },
    toggleView () {
      // Workaround for broken Safari that only lets us show the keyboard immediately on click ...
      let dummyInput = document.createElement('input')
      document.body.appendChild(dummyInput)
      dummyInput.focus()
      let r = this.$refs

      if (!this.showSelect) {
        // let oldName = this.item.itemName
        this.item.itemName = ''
        this.setDefaultVolumeAndWeightForStandardSurveyItem()
        setTimeout(function () {
          // TODO: set oldName to select's search field. Doesn't work: r.itemSelect.$refs.search.value = oldName
          r.itemSelect.$refs.search.focus()
          dummyInput.remove()
        })
      } else {
        // let oldName = r.itemSelect.$refs.search.value
        this.item.weight = null
        setTimeout(function () {
          // TODO: set oldName to name input field. Doesn't work: r.itemInput.value = oldName
          r.itemInput.focus()
          dummyInput.remove()
        })
      }
      this.showSelect = !this.showSelect
    },
    increaseCount () {
      this.item.count++
      this.updateCount()
    },
    decreaseCount () {
      this.item.count = (this.item.count - 1 < 0) ? 0 : this.item.count - 1
      this.updateCount()
    },
    increaseVolume () {
      if (this.item.volume == null) {
        this.item.volume = 0
      }
      this.item.volume = Number(this.item.volume)
      var newVolume = parseFloat(this.item.volume) + parseFloat(this.volumeStep)
      newVolume = newVolume.toFixed(2)
      this.item.volume = newVolume
      this.updateVolume()
    },
    decreaseVolume () {
      this.item.volume = Number(this.item.volume)
      var newVolume = parseFloat(this.item.volume) - parseFloat(this.volumeStep)
      newVolume = newVolume.toFixed(2)
      if (newVolume < 0) {
        newVolume = 0
      }
      this.item.volume = newVolume
      this.updateVolume()
    },
    updateName: function (selectedItem) {
      if (selectedItem) {
        this.item.itemNameId = selectedItem.value
      }
      this.$store.dispatch('updateItem', {
        storageKey: this.itemStorageKey,
        item: this.item
      }).then(() => {
        this.setDefaultVolumeAndWeightForStandardSurveyItem()
      })
    },
    setDefaultVolumeAndWeightForStandardSurveyItem () {
      var currentStandardSurveyItem = this.standardSurveyItemsOrdered.filter((standardSurveyItem) => {
        return standardSurveyItem.value === this.item.itemNameId
      })
      if (currentStandardSurveyItem.length > 0) {
        this.item.volume = Number(currentStandardSurveyItem[0].volume)
        this.item.weight = Number(currentStandardSurveyItem[0].weight)
        this.updateVolume().then(() => {
          this.updateWeight()
        })
      }
    },
    updateVolume: function () {
      return this.$store.dispatch('updateItemVolume', {
        storageKey: this.itemStorageKey,
        volume: Number(this.item.volume)
      }).then(() => {
        EventBus.$emit('calculateVolumes')
      })
    },
    updateWeight: function () {
      return this.$store.dispatch('updateItemWeight', {
        storageKey: this.itemStorageKey,
        weight: Number(this.item.weight)
      }).then(() => {
        EventBus.$emit('calculateVolumes')
      })
    },
    filterIgnoringAccentsAndCase (option, label, search) {
      function removeAccentsAndCase (string) {
        return string.normalize('NFD').toLowerCase().replace(/[\u0300-\u036f]/g, '')
      }
      return removeAccentsAndCase(label || '').indexOf(removeAccentsAndCase(search)) > -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/children/Item.vue